import { Country } from '~/Api/Country';

import Reimbursement from './Reimbursement';
import Sentence, { SentencePart } from './Sentence';
import VirtualPackReimbursement from './VirtualPackReimbursement';

export interface RawReimbursement {
	country: { name: string; alpha2: string };
	brandName: string;
	virtualPacks: {
		id: string;
		distinctName: string;
		sentences: { parts: SentencePart[] }[];
	}[];
}

export default function mapReimbursement(reimbursement: RawReimbursement): Reimbursement {
	return new Reimbursement(
		new Country(reimbursement.country.alpha2, reimbursement.country.name),
		reimbursement.brandName,
		reimbursement.virtualPacks.map(
			(virtualPack) =>
				new VirtualPackReimbursement(
					virtualPack.id,
					virtualPack.distinctName,
					virtualPack.sentences.map((sentence) => new Sentence(sentence.parts))
				)
		)
	);
}
